import {createAction} from '@reduxjs/toolkit';
import {BalancesSchema} from './balancesTypes';

export const balancesRoutine = (type => ({
    aborted: createAction(`${type}/ABORTED`),
    trigger: createAction(`${type}/TRIGGER`),
    success: createAction(`${type}/SUCCESS`, (data: BalancesSchema) => ({payload: data})),
    failure: createAction(`${type}/FAILURE`, (error: unknown) => ({payload: error})),
}))('BALANCES_REQUEST' as const);
